module.exports = __webpack_public_path__ + "img/warning-active.d2a36328.svg";